import { useMemo } from "react";
import type { CreditCard } from "@b2bportal/card-api";
import {
  CardPaymentSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";

export const useSelectedPaymentInformation = (): CreditCard | undefined => {
  const creditCards = useSelector(CardPaymentSelectors.getPaymentMethods);
  const selectedPaymentMethodId = useSelector(
    CardPaymentSelectors.getSelectedPaymentMethodId
  );

  const selectedPayment = useMemo(
    () => creditCards.find((payment) => payment.id === selectedPaymentMethodId),
    [creditCards, selectedPaymentMethodId]
  );

  return selectedPayment;
};
